import { DateTime } from "luxon";

function formatDateTimeString(string, fmt = "MMMM d, y 'at' t") {
  return DateTime.fromSQL(string).toFormat(fmt, { locale: "en-US" });
}

export default formatDateTimeString;
